import styles from "./TypingIndicator.module.css";
// Styles taken from https://cssloaders.github.io/

const TypingIndicator = () => {
  return <div className={styles.typing} />;
};

export default TypingIndicator;
